<div class="assistence py-5">
  <h2 class="title-section" [innerHTML]="data.text | htmlParse"></h2>
  <p class="description-section text-center" [innerHTML]="data.description | htmlParse"></p>
  <div class="wrapper-assistances">
    <div class="assistances" *ngFor="let card of data.cards">
        <app-card classCustom="round" [data]="card" [legalText]="data.legal_text"></app-card>
    </div>
  </div>
</div>